export default __webpack_public_path__ + "static/media/GitHub-Logo.11619ac0.svg";